import { render } from "./DashboardModules.vue?vue&type=template&id=101c17fd&scoped=true"
import script from "./DashboardModules.vue?vue&type=script&lang=js"
export * from "./DashboardModules.vue?vue&type=script&lang=js"

import "./DashboardModules.vue?vue&type=style&index=0&id=101c17fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101c17fd"]])

export default __exports__